module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm01"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm02"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm03"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction: Defining Happiness with Three Dimensions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part I: Seeking Happiness in Pleasure (Hedonic) Dimension")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 1")]), _vm._v(" Born in A Deprived Village")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 2")]), _vm._v(" Searching for Hedonic Happiness through Having")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 3")]), _vm._v(" Searching for Hedonic Happiness through Doing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 4")]), _vm._v(" Searching for Hedonic Happiness through Being")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 5")]), _vm._v(" Searching for Hedonic Happiness through Loving")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 6")]), _vm._v(" Scientific Research of Hedonic Happiness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part II: Seeking Happiness in Meaning (Eudemonic) Dimension")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 7")]), _vm._v(" Aristotle’s Eudemonic Happiness Model")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 8")]), _vm._v(" Searching for Eudemonic Happiness through Meaning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 9")]), _vm._v(" Searching for Eudemonic Happiness Through Believing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 10")]), _vm._v(" Scientific Research of Eudemonic Happiness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part III: Failure in Finding Happiness in Two Dimensions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 11")]), _vm._v(" American Dream or Nightmare?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 12")]), _vm._v(" Nietzsche’s Last Man and Unhappy Nihilist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 13")]), _vm._v(" Searching for Happiness while Sinking into Depression")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part IV: Seeking Happiness in Spiritual (G-donic) Dimension")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 14")]), _vm._v(" Searching for G-donic Happiness through Believing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 15")]), _vm._v(" Scientific Research of G-donic Happiness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Chapter 16")]), _vm._v(" Learned Lessons for a Happy Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Bonus Page 1")]), _vm._v(" Measure Three Dimensions of Your Happiness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Bonus Page 2")]), _vm._v(" Twelve Books for Higher Dimensions of Happiness")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0